import { SEVERITY_STYLES, formatDate, formatDuration } from "@/lib/incident";
import { API } from "@/lib/api";

export const IncidentList = ({ loading, incidents, selectedId, onSelect }) => (
  <div className="flex-1 overflow-y-auto scroll-thin" data-testid="incident-list">
    {loading ? (
      <div className="p-6 text-sm text-muted-foreground font-mono">Loading…</div>
    ) : incidents.length === 0 ? (
      <div className="p-6 text-sm text-muted-foreground">No incidents match.</div>
    ) : (
      incidents.map((i) => {
        const sev = SEVERITY_STYLES[i.severity] || SEVERITY_STYLES.Medium;
        const active = i.id === selectedId;
        return (
          <button key={i.id} onClick={() => onSelect(i.id)} data-testid={`incident-row-${i.id}`}
            className={`w-full text-left px-4 py-4 border-b border-border transition-colors duration-200 ${active ? "bg-[#0F0F10]" : "hover:bg-[#0A0A0A]"}`}>
            <div className="flex items-start gap-3">
              <span className={`w-2 h-2 rounded-full mt-1.5 shrink-0 ${sev.dot}`} />
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between gap-2">
                  <span className="font-medium truncate">{i.title}</span>
                  {active && <span className="w-1 h-1 rounded-full bg-[#007AFF]" />}
                </div>
                <p className="text-xs text-muted-foreground truncate mt-0.5">{i.location || "No location"}</p>
                <div className="flex items-center gap-3 mt-2 text-xs font-mono text-muted-foreground">
                  <span className={sev.text}>{i.severity}</span>
                  <span>{formatDate(i.created_at)}</span>
                  <span>{formatDuration(i.duration_seconds)}</span>
                  {i.call_cost != null && <span className="text-[#007AFF]">${Number(i.call_cost).toFixed(2)}</span>}
                </div>
              </div>
              {i.has_icon && (
                <img src={`${API}/incidents/${i.id}/icon?v=${encodeURIComponent(i.synopsis_generated_at || "")}`}
                  alt="" loading="lazy" data-testid={`incident-icon-${i.id}`}
                  className="w-24 h-24 shrink-0 rounded-sm border border-white/20 bg-[#141416] object-cover" />
              )}
            </div>
          </button>
        );
      })
    )}
  </div>
);
